import { BookingTypeEnum } from "@api";
import { toString } from "@helpers";

const hasTax = (type: BookingTypeEnum) =>
  ["sell", "dividend", "retained_dividend", "purchase_right"].includes(type);

const isCapitalMeasure = (type?: BookingTypeEnum) =>
  type ? ["carve_out", "switch"].includes(type) : false;

const parseOrUndefined = (value: string) => {
  try {
    if (!value || value === "") return undefined;
    if (value.endsWith(",") || value.endsWith(".")) return undefined;
    // do not use replaceAll because node does not implement it and it will fail in jest
    const usFormat = value.replace(/,/g, ".");
    return parseFloat(usFormat);
  } catch (err) {
    return undefined;
  }
};

const hasSecurityPrice = (type?: BookingTypeEnum) => {
  if (!type) return false;
  return type === "book_in";
};

export const useHelpers = () => {
  return {
    toString,
    isCapitalMeasure,
    parseOrUndefined,
    hasTax,
    hasSecurityPrice,
  };
};
